export const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name'
  },
  {
    id: 3,
    label: 'Email',
    intlKey: 'table.email'
  },
  {
    id: 4,
    label: '',
    intlKey: ''
  }
]
